import React, { Component } from 'react'
import './Banner.css'

export default class Banner extends Component {

	render() {

		return (
			<div className='banner'>
				<img src={require('../assets/banner-mobile.jpg')}/>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Banner.js